// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ccPopoverBox{padding:0;box-shadow:0 0 12px 0 rgba(0,0,0,.18);border:none!important}.ccPopoverBox[x-placement^=bottom] .popper__arrow:after,.ccPopoverBox[x-placement^=top] .popper__arrow:after{border-bottom-color:inherit}.ccPopoverBox[x-placement^=left] .popper__arrow:after,.ccPopoverBox[x-placement^=right] .popper__arrow:after{border-right-color:inherit;border-left-color:inherit}", ""]);
// Exports
module.exports = exports;
